/*更新会员*/
export function updateMember(data = {}) {
    return abp.ajax({
        url: '/api/services/app/Member/UpdateMember',
        method: 'put',
        data: data
    })
}

/**/
export function GetUserProjects(userId) {
    return abp.ajax({
        url: '/api/services/app/Project/GetUserProjects',
        method: 'get',
        params: {userId: userId}
    })
}
